import videoModalinit from '../components/video-modal';

//  Creating data
function getData(postType, page, postsPerPage,iconUrl,linkText) {
    return {
        action: "archive_academy_tabs",
        postType: postType,
		page: page,
		postsPerPage: postsPerPage,
		iconUrl:iconUrl,
		linkText: linkText,
    };
}
// Initiating AJAX request
function sendRequestToServer(data) {
    fetch(themeData.ajaxUrl, {
        method: "post",
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        body: new URLSearchParams(data).toString(),
    }).then(function (response) {
        return response.json();

    }).then(function (response) {
		console.log(response);
        const pageResults = document.querySelector('.js-page-results');
		const loadMoreBtn = document.querySelector('.js-posts-load-more');

		loadMoreBtn.setAttribute('data-current-page', response.current_page);

		if ( response.current_page >= response.max_pages ) {
			loadMoreBtn.classList.add('hidden');
		} else {
			loadMoreBtn.classList.remove('hidden');
		}

		// console.log(response.current_page);
		// console.log(pageResults);


		if ( response.current_page > 1 ) {
			pageResults.insertAdjacentHTML('beforeend', response.results);
		} else {
			pageResults.innerHTML = response.results;
		}

        videoModalinit();
    });
}

function loadMoreHandler() {
	const loadMoreBtn = document.querySelector('.js-posts-load-more');

	if (loadMoreBtn) {
		loadMoreBtn.addEventListener('click', () => {
			let currentPage = loadMoreBtn.getAttribute('data-current-page'),
				nextPage = parseInt(currentPage) + 1,
				postType = loadMoreBtn.getAttribute('data-post-type'),
				postsPerPage = loadMoreBtn.getAttribute('data-posts-per-page'),
				iconUrl = loadMoreBtn.getAttribute('data-icon-url'),
				linkText = loadMoreBtn.getAttribute('data-link-text'),
				data = getData(postType, nextPage, postsPerPage, iconUrl, linkText);

			sendRequestToServer(data);
		})
	}
}

export { loadMoreHandler };

